import script from "./SimpleKeyboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleKeyboard.vue?vue&type=script&setup=true&lang=js"

import "./SimpleKeyboard.vue?vue&type=style&index=0&id=22392931&lang=less"

const __exports__ = script;

export default __exports__